import { ModalInformacionPedido } from "./components/ModalInfoPedido";
import { ModalConfirmarLanzar } from "./components/ModalConfirmarLanzar";
import { ModalEnviarPedidos, } from "./components/ModalEnviarPedido";
import { TypedTable } from "@/components/ui/table/TypedTable";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, type NavigateFunction } from "react-router";
import { createColumnHelper, tableFeatures, type RowSelectionState } from "@tanstack/react-table";
import { useDisclosure, useDisclosureData } from "@/hooks/useModal";
import { ModalConfirmarEliminar } from "./components/ModalConfirmarEliminar";
import type { CicloVenta, PedidoVenta } from "./LanzarCiclos";
import { CommonFeatures } from "@/hooks/useTanstackTable";
import { Constantes } from "@/ts/constantes";
import { getSelectionCell } from "@/components/ui/table/datatable";
import { Loading } from "@/components/Loading/Loading";


export function TablaPedidos(props: { readonly data: PedidoVenta[]; readonly cicloActual: CicloVenta | null; }) {
	const disclosureInfo = useDisclosureData(0);
	const disclosureRevertir = useDisclosure();
	const disclosureLanzar = useDisclosure();
	const disclosureMarcarEnviados = useDisclosure();
	const [rowSelection, setRowSelection] = useState<RowSelectionState>({});
	const navigate = useNavigate();

	const { columns, features } = useMemo(() => Columns(navigate, disclosureInfo.open), [navigate, disclosureInfo.open]);


	// Reset selected rows when data changes
	useEffect(() => {
		//TODO Reemplazar con dirty y pristine para evitar resetear la selección innecesariamente
		// eslint-disable-next-line react-hooks/set-state-in-effect
		setRowSelection({});
	}, [props.data]);

	return (
		<>
			<TypedTable
				className="dataTable display"
				features={features}
				columns={columns}
				data={props.data}

				noResultsMessage="No se encontraron pedidos"
				errorMessage="Error al cargar los pedidos"
				isLoading={props.cicloActual == null}
				isError={false}

				getRowId={row => row.idPedido.toString()}
				selection={rowSelection}
				setSelection={setRowSelection}
			/>
			{props.cicloActual != null && <>
				<div style={{ display: "flex", justifyContent: "space-evenly", padding: "10px 0" }}>
					{props.cicloActual.idCiclo == null && Constantes.existenCiclos ? (
						<button className="btnPrimary" onClick={disclosureLanzar.open} type="button">
							Asignar a ciclo
						</button>
					) : null}
					{props.cicloActual.idCiclo != null && Constantes.existenCiclos ? (
						<button className="btnPrimary" onClick={disclosureRevertir.open} type="button">
							Retirar de ciclo
						</button>
					) : null}

					<button className="btnPrimary" onClick={disclosureMarcarEnviados.open} type="button">
						Marcar como enviados
					</button>
				</div>

				<ModalInformacionPedido
					show={disclosureInfo.isOpen}
					idPedido={disclosureInfo.data}
					close={disclosureInfo.close}
				/>

				{props.cicloActual.idCiclo == null && (
					<ModalConfirmarLanzar
						show={disclosureLanzar.isOpen}
						close={disclosureLanzar.close}
						pedidosMarcados={rowSelection}
					/>
				)}
				{props.cicloActual.idCiclo != null && (
					<ModalConfirmarEliminar
						show={disclosureRevertir.isOpen}
						close={disclosureRevertir.close}
						pedidosMarcados={rowSelection}
						idCiclo={props.cicloActual.idCiclo}
					/>
				)}
				<ModalEnviarPedidos
					show={disclosureMarcarEnviados.isOpen}
					close={disclosureMarcarEnviados.close}
					pedidosMarcados={rowSelection}
				/>
			</>}
		</>
	);
}

function Columns(navigate: NavigateFunction, openInfo: (idPedido: number) => void) {
	const columnHelper = createColumnHelper<typeof features, PedidoVenta>();
	const features = tableFeatures(CommonFeatures);

	const formatter = new Intl.DateTimeFormat("es-ES");

	function getBotonesPedido(pedido: PedidoVenta) {
		const iconEmpaquetado = (pedido.empaquetado == true ? "package-closed.svg" : "package-open.svg");

		const onClickInfo = () => { openInfo(pedido.idPedido); };
		const onClickEmpaquetado = () => {
			const params = new URLSearchParams({
				"idPedido": String(pedido.idPedido),
			});

			void navigate(`/empaquetado?${params.toString()}`);
		};

		return (
			<div className='containerIconoPedido'>
				<button type="button" className="btnIcon" onClick={onClickInfo}>
					<img className="square35" src="/img/icons/info.svg" />
				</button>
				<button type="button" className="btnIcon" onClick={onClickEmpaquetado}>
					<img className="square35" src={`/img/icons/${iconEmpaquetado}`} />
				</button>
			</div>
		);
	}

	const columns = columnHelper.columns([
		columnHelper.display({
			id: "checkbox",
			// header: () => <input type="checkbox" className="checkboxRow" style={{ height: 20 }} />,
			cell: (info) => getSelectionCell(info.row),
		}),

		columnHelper.accessor("fechaPedido", { header: "Fecha Pedido", cell: info => formatter.format(info.getValue() * 1000) }),
		columnHelper.display({ id: "medio", header: "Medio", cell: info => `${info.row.original.idTransporte} - ${info.row.original.nombreTransporte}`, }),
		columnHelper.display({ id: "cliente", header: "Cliente", cell: info => `${info.row.original.idCliente} - ${info.row.original.nombreCliente}`, }),
		columnHelper.accessor("idPedido", { header: "ID Pedido" }),
		// columnHelper.accessor('peso_total', { header: 'Peso' }),
		columnHelper.accessor("importe", { header: "Importe", cell: info => `${info.getValue()}€` }),
		columnHelper.display({ id: "acciones", header: "", cell: info => getBotonesPedido(info.row.original) }),	//, meta: { className: "p-0 h-full" }
	]);
	return { columns, features };
}